import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { themeConWeb } from '@app/util/modernThemeConweb'
import { connect } from 'react-redux'
import { Box, Container, Typography } from '@material-ui/core'

import { joinTeamStart, setNextStepTeamName } from '../../../redux/modules/teamOnboarding'
import {
  publishClickedCreateTeamButton,
  publishViewedCreateJoinDialog,
} from '../../../util/events/teamsOnboardingEventPublishers'
import { loadPotentialTeamsStart } from '../../../redux/modules/teamOnboarding'
import { selectCurrentUser } from '../../../redux/modules/selectors'
import PromoCreateTeam from './PromoCreateTeam'
import PotentialTeams from './PotentialTeams'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  topWrapper: {
    position: 'relative',
    backgroundColor: themeConWeb.color.grey,
    minHeight: '50%',
    width: '100%',
    paddingBottom: theme.spacing(3),
  },
  bottomWrapper: {
    width: '100%',
    paddingBottom: theme.spacing(2),
  },
  divider: {
    height: '50px',
    width: '50px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    backgroundColor: themeConWeb.color.white,
    position: 'absolute',
    bottom: '-25px',
    left: '50%',
    fontWeight: 500,
  },
  joinTeamContainer: {
    maxWidth: '420px',
    paddingTop: theme.spacing(5),
    textAlign: 'center',
  },
  gridItem: {
    padding: theme.spacing(2),
  },
  title: {
    fontWeight: 500,
  },
}))

const StepCreateOrJoinTeam = ({
  currentUser,
  potentialTeams,
  isLoadingPotentialTeams,
  isJoiningTeam,
  setNextStepTeamName,
  loadPotentialTeamsStart,
  joinTeamStart,
}) => {
  const classes = useStyles()

  const onCreateTeam = () => {
    publishClickedCreateTeamButton()
    setNextStepTeamName()
  }

  useEffect(() => {
    publishViewedCreateJoinDialog()

    loadPotentialTeamsStart()
  }, [loadPotentialTeamsStart])

  return (
    <div className={classes.root}>
      <div className={classes.topWrapper}>
        <PromoCreateTeam onCreateTeam={onCreateTeam} />
        <div className={classes.divider}>or</div>
      </div>
      <div className={classes.bottomWrapper}>
        <Container className={classes.joinTeamContainer}>
          <Typography className={classes.title}>
            Is your team already on Foodsby? Join them.
          </Typography>
          <Box marginTop={2} paddingX={4}>
            <PotentialTeams
              userEmail={currentUser.email}
              teams={potentialTeams}
              loading={isLoadingPotentialTeams}
              onJoin={joinTeamStart}
              submitting={isJoiningTeam}
            />
          </Box>
        </Container>
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  const { potentialTeams, isLoadingPotentialTeams, isJoiningTeam } = state.teamOnboarding
  const currentUser = selectCurrentUser(state)

  return {
    currentUser,
    potentialTeams,
    isJoiningTeam,
    isLoadingPotentialTeams,
  }
}

const mapDispatchToProps = {
  setNextStepTeamName,
  loadPotentialTeamsStart,
  joinTeamStart,
}

export default connect(mapStateToProps, mapDispatchToProps)(StepCreateOrJoinTeam)
